import { OutputLayout } from './OutputLayout';
import { LookupsFetcher } from '../common';
import { ContainerInputProps } from '../../../common/components/input-props';
import { useDataStore } from '@/app/core/components/step-wizard';
import { useUndo } from '@/app/core/helpers/use-undo-helper';
import {
  OutputLayoutField,
  outputLayoutInformationValidator,
} from '@ssar-app/domain';
import { useEffect, useState } from 'react';

export const OutputLayoutContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();

  const OutputLayoutHandler = () => {
    const [
      { present: tableRows },
      { undo, redo, set, reset, canUndo, canRedo },
    ] = useUndo<OutputLayoutField[]>([]);

    return { tableRows, undo, redo, set, reset, canUndo, canRedo };
  };

  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);

  return (
    <>
      {subCode !== '' && (
        <LookupsFetcher
          subCode={subCode}
          onSuccess={(lookupsManager, isLoading) => {
            return (
              <OutputLayout
                stepKey={keys}
                moduleProps={{
                  lookupsManager: lookupsManager,
                  isLoading: isLoading,
                  actionsHandler: OutputLayoutHandler(),
                }}
                validator={outputLayoutInformationValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
